var _style, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 30,
    viewBox: "0 0 120 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Ellipse_131_513 {\n\tanimation: 1.4s ease-in-out 0s infinite normal forwards running Ellipse_131_513;\n\ttransform-box: fill-box;\n\ttransform-origin: 50% 50%;\n\ttransform: translateX(14px) translateY(14px);\n}\n@keyframes Ellipse_131_513 {\n\t0% {\n\t\ttransform: translateX(15px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t\topacity: 1;\n\t}\n\t35.71% {\n\t\ttransform: translateX(15px) translateY(15px);\n\t\trx: 15px;\n\t\try: 15px;\n\t}\n\t71.43% {\n\t\ttransform: translateX(15px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t}\n\t78.57% {\n\t\ttransform: translateX(15px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t}\n\t100% {\n\t\ttransform: translateX(15px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t\topacity: 1;\n\t}\n}.Ellipse_132_766 {\n\tanimation: 1.4s ease-in-out 0s infinite normal forwards running Ellipse_132_766;\n\ttransform-box: fill-box;\n\ttransform-origin: 50% 50%;\n\ttransform: translateX(59px) translateY(14px);\n}\n@keyframes Ellipse_132_766 {\n\t0% {\n\t\topacity: 1;\n\t}\n\t14.29% {\n\t\ttransform: translateX(60px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t}\n\t50% {\n\t\ttransform: translateX(60px) translateY(15px);\n\t\trx: 15px;\n\t\try: 15px;\n\t}\n\t85.71% {\n\t\ttransform: translateX(60px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t}\n\t100% {\n\t\ttransform: translateX(60px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t\topacity: 1;\n\t}\n}.Ellipse_133_777 {\n\tanimation: 1.4s ease-in-out 0s infinite normal forwards running Ellipse_133_777;\n\ttransform-box: fill-box;\n\ttransform-origin: 50% 50%;\n\ttransform: translateX(104px) translateY(14px);\n}\n@keyframes Ellipse_133_777 {\n\t0% {\n\t\topacity: 1;\n\t}\n\t28.57% {\n\t\ttransform: translateX(105px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t}\n\t64.29% {\n\t\ttransform: translateX(105px) translateY(15px);\n\t\trx: 15px;\n\t\try: 15px;\n\t}\n\t100% {\n\t\ttransform: translateX(105px) translateY(15px);\n\t\trx: 1px;\n\t\try: 1px;\n\t}\n}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0_457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "black",
    className: "Ellipse_131_513",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "black",
    className: "Ellipse_132_766",
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "black",
    className: "Ellipse_133_777",
    rx: 1,
    ry: 1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDots);
export default __webpack_public_path__ + "static/media/loading-dots.7c44abebe86eefb87e9fa7a42677d12c.svg";
export { ForwardRef as ReactComponent };